// LB-6162: invite emails link to /login?invite=<token>, a single-use token the API exchanges for the
// user's chosen password. Links sent before that carry ?username=&temppassword= and keep working
// until the user sets a password or is sent a new invite.
export const INVITE_TOKEN_PARAM = 'invite';
export const INVITE_LINK_INVALID_ERROR_CODE = 'InviteLinkInvalid';
export const readInviteLink = search => {
  const params = new URLSearchParams(search);
  const inviteToken = params.get(INVITE_TOKEN_PARAM) || null;
  const legacyUsername = params.get('username') || null;
  const legacyTempPassword = params.get('temppassword') || null;
  return {
    inviteToken,
    legacyUsername,
    legacyTempPassword,
    isInviteLink: !!inviteToken || !!(legacyUsername && legacyTempPassword)
  };
};
const INVITE_CREDENTIAL_PARAMS = [INVITE_TOKEN_PARAM, 'username', 'temppassword'];

// The token (or an older link's temporary password) works until the password is set, so keep it out of
// the address bar, and the page URL analytics scripts read, once the page has it in memory.
export const removeInviteCredentialsFromUrl = () => {
  const url = new URL(window.location.href);
  const present = INVITE_CREDENTIAL_PARAMS.filter(name => url.searchParams.has(name));
  if (!present.length) {
    return;
  }
  present.forEach(name => url.searchParams.delete(name));
  window.history.replaceState(window.history.state, '', "".concat(url.pathname).concat(url.search).concat(url.hash));
};